import { Star } from "lucide-react";
import { useLocale } from "@/i18n/detect";

const Testimonials = () => {
  const { ui } = useLocale();
  const t = ui.testimonials;
  return (
    <section id="testimonials" className="bg-muted/40 py-24">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">{t.eyebrow}</span>
          <h2 className="mt-3 font-display text-4xl font-bold text-secondary md:text-5xl">
            {t.title}
          </h2>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {t.items.map((item) => (
            <figure key={item.name} className="flex flex-col rounded-2xl border border-border bg-card p-7 shadow-card">
              <div className="flex gap-0.5 text-primary">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-current" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-lg leading-relaxed text-secondary">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-6 border-t border-border pt-4">
                <div className="font-semibold text-secondary">{item.name}</div>
                <div className="text-sm text-muted-foreground">{item.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
